import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const TableIndex = lazy(() => import('./table/Index'))
const Index = lazy(() => import('./Index'))

export const CrewDailyAllowanceRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--crew-daily-allowance']}>
    <Route path=':id/details/*' element={<Index />} />
    <Route path='*' element={<TableIndex />} />
  </SubRouter>
))
